import React, { useState, useEffect } from "react";
import _ from "lodash";
import { useSelector, useDispatch } from "react-redux";
import "./main.css";
import Dashboard from "./components/Dashboard";
import Track from "./components/Track";
import TrackHeader from "./components/TrackHeader";
import { genomeOptions } from "./constants";
import { dataFileManager } from "./dataFileManager";
import { initializeRecord } from "./helpers/helpers";
import { scaleLinear } from 'd3';
import RegionHop from "./components/RegionHop";

function App() {

  const g = Object.keys(genomeOptions);
  //const [calculatedPositions, setCalculatedPositions] = useState(initializeRecord(g, []));
 
  // const submitCalculatedPositions = (pos, genome) => {
  //   calculatedPositions[genome] = pos;
  //   setCalculatedPositions({...calculatedPositions});
  // };

  return (
    <div className="main-app">
      <Dashboard />
      <TrackHeader> <p>Genome</p> </TrackHeader>
      <Track trackType="Genome" />
      <TrackHeader> <p>Chromosome</p> </TrackHeader>
      <Track
        trackType="Chromosome"
      />

      <TrackHeader>
        <p>Subregion</p>
        {/* <RegionHop/> */}
      </TrackHeader>
      <Track
        trackType="Subregion"
      />

      <TrackHeader> <p>Subregion Selection</p> </TrackHeader>
      <Track
        trackType="SubregionSelection"
        // calculatedPositions={calculatedPositions}
        // submitCalculatedPositions={submitCalculatedPositions}
      />
    </div>
  );
}
export default App;
